import { loadStripe } from '@stripe/stripe-js';
import Pristine from 'pristinejs';
import * as Sentry from "@sentry/browser";
import Auth, { checkAuthStatusAsync, isAuthenticated } from './auth';
import { DASHBOARD_URL, PAYPAL_CLIENT_ID } from './config';
import { startLoading, finishLoading } from './loading';
import { countryCodeCurrency, createXHR, dashboardProductMap, PristineConfig, supportedCurrencies, showOverlay } from './utils';

const PayPalBtnStyle = {
  color: 'gold',
  height: 40,
  layout: 'horizontal',
  tagline: false,
  shape: 'pill',
  label: 'checkout'
};
let eventBuf = null;
const init = () => {
  const path = '/checkout';
  if (window.location.pathname.includes(path)) {
    return;
  }

  configureCurrency();
  // setup currency selector
  const currencySelectorEl = document.getElementById('currency-selector');
  if (currencySelectorEl) {
    document.getElementById('currency-selector').addEventListener('change', (event) => {
      const selectedCurrency = event.currentTarget.value;
      window.localStorage.setItem('currency', selectedCurrency);
      injectCurrency(selectedCurrency);
    });
  }
  // setup discount code form
  // setup payments
  // NOTE: book
  document.querySelectorAll('.js-show-purchase-form').forEach(el => el.addEventListener('click', openPurchaseOverlay));
  // NOTE: course
  // document.querySelectorAll('.js-start-course-button').forEach(el => el.addEventListener('click', openSelectionSubscriptionOverlay));
  // NOTE: from redeem page
  document.querySelectorAll('.discount-main-btn').forEach(el => el.addEventListener('click', openSelectionSubscriptionOverlayWithDiscount));
  // document.querySelectorAll('.js-click-on-card-from-selection-subscription-form').forEach(el =>
  //   el.addEventListener('click', clickOnCardFromSelectionSubscriptionForm));

  // NOTE: plans buttons
  document.querySelector('.c-header__plans-btn').addEventListener('click', (event) => {
    if (!isAuthenticated) {
      window.sessionStorage.setItem('string-redirect-google-auth', 'type=checkout&product_id=1');
      Auth.openSignUpOverlay(event, { flow: 'returnCheckout' });
      return;
    }
    window.location.href = '/checkout';
  })
  const subStatus = {
    isSubscribed: false,
    isStarted: false,
    isPastDue: false,
  }
  // NOTE: checkout course
  document.querySelectorAll('.js-start-course-button').forEach(el => el.addEventListener('click', async (event) => {
    if (event) {
      event.preventDefault();
      startLoading(null, event.target);
    }
    const courseDataEl = document.getElementById('course-data');
    if (!courseDataEl) {
      window.location.href = '/';
      return;
    }
    const course = JSON.parse(courseDataEl.innerHTML);
    if (course === null) {
      window.location.href = '/';
      return;
    };

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('type', encodeURIComponent('course'));
    urlParams.set('product_id', encodeURIComponent(course.id));
    
    if (!isAuthenticated) {
      //      // if user is not authenticated, start sign up flow first
      window.sessionStorage.setItem('string-redirect-google-auth', urlParams.toString());
      finishLoading(null, event.target);
      Auth.openSignUpOverlay(event, { flow: 'checkout', data: { urlParams: urlParams.toString() } });
      return;
    }
  
    initialDataPurchaseSubscription();
    payment.getSubscriptionRelevance().then((res) => {
      subStatus.isSubscribed = res.is_subscribed;
      subStatus.isStarted = res.is_started;
      subStatus.isPastDue = res.is_past_due;

      if (subStatus.isSubscribed) {
        window.location.href = `${DASHBOARD_URL}/${dashboardProductMap[payment.product.type]}/${payment.product.slug}`;
      }
      else {
        if (subStatus.isStarted) {
          window.location.href = `${DASHBOARD_URL}`;
        }
        if (subStatus.isPastDue) {
          window.location.href = '/checkout/?' + urlParams.toString();
        }
        
        window.location.href = '/checkout/?' + urlParams.toString();
      }
    }).catch(err => {
      console.err(err);
      finishLoading(null, event.target);
    })
  }));
  // NOTE: check if auth
  checkAuthStatusAsync().then(isAuth => {
    if (!isAuth) {
      return;
    }

    // NOTE: render plans button & change start course btn text
    const viewPlansBtn = document.querySelector('.c-header__plans-btn');
    const startCourseBtn = document.querySelector('.js-start-course-button');
    if (viewPlansBtn && startCourseBtn) {
      startCourseBtn.innerText = "Start Course";
      startCourseBtn.dataset['loadingFinished'] = "Start Course";
      document.querySelector('.js-start-course-button + .t-caption').innerText = "Click to add course to your dashboard";

      payment.getSubscriptionsStatus().then(result => {
        const hasSubscription = result.user.has_subscription;

        if (!hasSubscription) {
          viewPlansBtn.classList.remove('hidden');
        }
      })

      return;
    }

    if (viewPlansBtn) {
      payment.getSubscriptionsStatus().then(result => {
        const hasSubscription = result.user.has_subscription;

        if (!hasSubscription) {
          viewPlansBtn.classList.remove('hidden');
        }
      })
    }

    if (startCourseBtn) {
      startCourseBtn.innerText = "Start Course";
      startCourseBtn.dataset['loadingFinished'] = "Start Course";
      document.querySelector('.js-start-course-button + .t-caption').innerText = "Click to add course to your dashboard";
    }
  })
}
const openSelectionSubscriptionOverlayWithDiscount = async (event) => {
  if (event) {
    event.preventDefault();
    event.target.disabled = true;
    startLoading(null, event.target);
  }
  if (!isAuthenticated) {
    window.sessionStorage.setItem('string-redirect-google-auth', 'type=checkout&product_id=1');
    //     // if user is not authenticated, start sign up flow first
    eventBuf = event;
    
    finishLoading(null, event.target);
    Auth.openSignUpOverlay(event, { flow: 'discount' });
    return;
  }
  payment.installationDiscount(document.getElementById('discount-code-input').value);
  let containerError = document.getElementById("discount-error-wrapper");
  containerError.innerHTML = "";
  let dynamicErrorOutput = document.createElement("div");
  dynamicErrorOutput.innerHTML = "";
  let hasSubscriptions = false
  let message;
  let getIsPaid;

  payment.getSubscriptionsStatus().then((res) => {
    hasSubscriptions = res.user.has_subscription;
    payment.redeemACode(payment.discountCode).then((res) => {
      dynamicErrorOutput.innerHTML = `
            <p>Success. Redirecting to checkout...</p>`;
      containerError.appendChild(dynamicErrorOutput);

      setTimeout(() => {
        window.location.href = '/checkout';
      }, 2000);
    }).catch((error) => {
      if (error.message) {
        message = error?.message;
      }
      else {
        message = ""
      };

      dynamicErrorOutput.innerHTML = `
            <p>${message}</p>`;
      containerError.appendChild(dynamicErrorOutput);

      if (event) {
        event.target.disabled = false;
        finishLoading(null, event.target);
      }
    })
  })
}

const clickOnCardFromSelectionSubscriptionForm = (event) => {
  if (event) {
    event.preventDefault();
  }
}

const clickOnSubscriptionPlan = (id, currency, price, interval, freeTrialInDays) => {
  // NOTE:
  setupPurchaseSubscriptionForm(currency, price, interval, freeTrialInDays);
  if (payment.stripeElements === null) {
    payment.loadStripeElements();
  }
  payment.priceId = id;

  showOverlay('purchase-subscription-overlay');
}

// NOTE:
const openSelectionSubscriptionOverlay = async (event) => {
  let isSubscribed = false;
  let isStarted = false;
  let isPastDue = false;
  let currency = window.localStorage.getItem('currency');
  if (event) {
    event.preventDefault();
  }
  if (!isAuthenticated) {
    //      // if user is not authenticated, start sign up flow first
    Auth.openSignUpOverlay(event, { flow: 'authenticateSelection' });
    return;
  }
 
  initialDataPurchaseSubscription();
  payment.getSubscriptionRelevance().then((res) => {
    isSubscribed = res.is_subscribed;
    isStarted = res.is_started;
    isPastDue = res.is_past_due;

    if (isSubscribed) {
      window.location.href = `${DASHBOARD_URL}/${dashboardProductMap[payment.product.type]}/${payment.product.slug}`;
    }
    else {
      if (isStarted) {
        window.location.href = `${DASHBOARD_URL}`;
      }
      if (isPastDue) {
        window.location.href = `${DASHBOARD_URL}/student/settings`;
      }

      else {
        document.querySelectorAll('.js-on-select-paypal-purchase-method').forEach(el => el.addEventListener('click', onSelectPaypalPurchaseMethod));
        document.querySelectorAll('.js-on-select-card-purchase-method').forEach(el => el.addEventListener('click', onSelectCardPurchaseMethod));

        showOverlay('selection-subscription-overlay');
        var container = document.getElementById("options-subscription-types-wrapper");
        container.innerHTML = "";

        payment.getProductsWithSubscriptions().then((res) => {
          res.forEach((i) => {
            let trial = i?.recurring?.trial_period_days;
            let count = i?.recurring?.interval_count;
            if (i?.recurring?.interval == "year") count = 12;
            let freeTrialInDays = i?.free_trial_in_days;
            let freeTrialInDaysForButtons = i?.free_trial_in_days ? `${i?.free_trial_in_days} days FREE TRIAL,then` : "";
            if (!!trial) {
              trial = `Free trial ${trial} days`;
            }
            else {
              trial = ``;
            }
            switch (currency.toLowerCase()) {
              case "usd":
                i.unit_amount = i.currency_options['usd'].unit_amount;
                i.currency = "$"
                break;
              case "gbp":
                i.unit_amount = i.currency_options['gbp'].unit_amount;
                i.currency = "£"
                break;
              case "eur":
                i.unit_amount = i.currency_options['eur'].unit_amount;
                i.currency = "€"
                break;
              default:
                i.currency = ""
                break;
            }
            let dynamicButton = document.createElement("div");//js-loading-spinner
            dynamicButton.id = "myButton";
            dynamicButton.innerHTML = `<div class="options-subscription-types-element">
          <div class="options-subscription-types-element-label">
            <div><b>${freeTrialInDaysForButtons}</b></div>
            <div>Billed ${(i?.recurring?.interval == "month" && count == 3) ? `quarter` : i?.recurring?.interval}ly</div>
            <div>${i.currency}${(i.unit_amount / 100 / +count).toFixed(2)}/${i?.recurring?.interval == "day" ? "day" : "month"}</div>
            <div>${trial}</div>
          </div>
          <button class="purchase-subscription-pay-card-btn-select js-loading-spinner" type="Submit" data-loading-finished="Select" >
            Select
          </button>
        </div>`;
            dynamicButton.onclick = function () {
              clickOnSubscriptionPlan(i.id, i.currency, i.unit_amount / 100, { count: count, name: i?.recurring?.interval }, freeTrialInDays);
              document.querySelectorAll('.options-wrapper').forEach(el =>
                el.addEventListener('click', event => {
                  startLoading(null, event.target);
                }));
            };
            container.appendChild(dynamicButton);
          })
        }, (err) => {
          console.log("error", err);
        });
      }

    }
  }, (err) => {
    console.log(err);
  }).finally(() => {
    if (event) {
      event.target.disabled = false;
      finishLoading(null, event.target);
    }
  });
}
const onSelectPaypalPurchaseMethod = (event) => {
  if (event) {
    event.preventDefault();
  }

  document.querySelectorAll('.paypal-button-color-black').forEach(el => {
    el.classList.remove('..paypal-button.paypal-button-color-black');
    el.style.background = 'green'
  })

  highlightPurchaseBtn('.purchase-subscription-payment-method-pay-pal');
}

const onSelectCardPurchaseMethod = (event) => {
  if (event) {
    event.preventDefault();
  }

  highlightPurchaseBtn('.purchase-subscription-payment-method-card');
}

const highlightPurchaseBtn = (className) => {

  document.querySelectorAll('.highlight-purchase-btn').forEach(btn => {
    btn.classList.remove('highlight-purchase-btn');
  });

  document.querySelectorAll(className).forEach(btn => {
    btn.classList.add('highlight-purchase-btn');
  })

  switchPurchaseBtn(className);
}

const switchPurchaseBtn = (className) => {
  switch (className) {
    case '.purchase-subscription-payment-method-pay-pal': {
      document.querySelectorAll('.purchase-subscription-payment-method-card').forEach(btn => {
        btn.style.display = 'inline-block';
      });
      document.getElementById('purchase-subscription-form').style.display = 'none';

      document.getElementById('purchase-subscription-pay-paypal-container').style.display = 'block';
      document.getElementById('purchase-subscription-pay-card-container').style.display = 'none';
    } break;

    case '.purchase-subscription-payment-method-card': {
      document.querySelectorAll(className).forEach(btn => {
        btn.style.display = 'none';
      })
      document.getElementById('purchase-subscription-form').style.display = 'block';

      document.getElementById('purchase-subscription-pay-paypal-container').style.display = 'none';
      document.getElementById('purchase-subscription-pay-card-container').style.display = 'block';
    } break;
  }
}

// NOTE:
const openPurchaseOverlay = event => {
  if (event) {
    event.preventDefault();
  }
  setupPurchaseForm(event);
  if (!isAuthenticated) {
    // if user is not authenticated, start sign up flow first
    Auth.openSignUpOverlay(event, { flow: 'authenticatePurchase' });
    return;
  }
  showOverlay('purchase-overlay');
  //openSelectionSubscriptionOverlay(event);
}

const openGiftOverlay = event => {
  if (event) {
    event.preventDefault();
  }

  setupPurchaseGiftForm();
  showOverlay('purchase-gift-overlay');
}

// Uses Cloudflare GEO IP Country Code
const configureCurrency = () => {
  const currency = window.localStorage.getItem('currency');
  if (currency) {
    injectCurrency(currency);
  } else {
    fetchCountryCode();
  }
}

const fetchCountryCode = () => {
  // Construct an HTTP request
  const xhr = createXHR({
    method: 'GET',
    endpoint: '/api/v2/country-code'
  });
  xhr.onload = () => {
    const data = JSON.parse(xhr.responseText);
    const countryCode = Object.keys(countryCodeCurrency).indexOf(data.country_code) !== -1 ? data.country_code : 'US';
    const currency = countryCodeCurrency[countryCode];
    const supportedCurrency = supportedCurrencies.indexOf(currency) !== -1 ? currency : 'USD';
    window.localStorage.setItem('currency', supportedCurrency);
    window.localStorage.setItem('countryCode', countryCode);
    injectCurrency(supportedCurrency);
  };
}

const injectCurrency = currency => {
  const currencyLower = currency.toLowerCase();
  // clear currency classes
  document.body.classList.remove(...supportedCurrencies.map(c => `currency-${c.toLowerCase()}`));
  // add selected currency class
  document.body.classList.add(`currency-${currencyLower}`);
  // update prices with new currency
  document.querySelectorAll('.js-price').forEach(el => el.textContent = el.dataset[currency.toLowerCase()]);
  document.querySelectorAll('.js-price-input').forEach(el => el.value = el.dataset[currency.toLowerCase()]);
  // update currency form inputs
  document.querySelectorAll('input.js-currency').forEach(el => el.value = currency);
  // update currency selector
  document.getElementById('currency-selector').value = currency;

  // Load PayPal script
  const existingScript = document.getElementById('paypal-script');
  if (existingScript !== null && existingScript.src.indexOf(`currency=${currency}`) === -1) {
    // remove current paypal script first
    document.getElementById('paypal-script').remove();
    // remove rendered paypal buttons
    payment.paypal.button = null;
    gift.paypal.button = null;
    document.querySelectorAll('.js-paypal-btn-element').forEach(el => el.innerHTML = '');
  }

  // inject paypal script
  /*const scriptEl = document.createElement('script');
  scriptEl.id = 'paypal-script';
  scriptEl.src = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&currency=${currency}&intent=capture`;
  scriptEl.onload = scriptEl.onreadystatechange = () => {
    payment.initPayPal();
    gift.initPayPal();
  }
  document.head.appendChild(scriptEl);*/
}

const setupPurchaseForm = () => {
  const canMakePayment = document.getElementById('purchase-form');
  const discountForm = document.getElementById('discount-purchase-form');
  discount.setupForm(discountForm);
  try {
    payment.setupForm(canMakePayment);
  }
  catch (error) {
    console.log("error SetupPurchaseForm", error);
  }
}
const initialDataPurchaseSubscription = () => {
  const purchaseSubscriptionForm = document.getElementById('purchase-subscription-form');
  payment.setupForm(purchaseSubscriptionForm);
}
const setupPurchaseSubscriptionForm = (currency, price, interval, freeTrialInDays) => {
  const purchaseSubscriptionForm = document.getElementById('purchase-subscription-form');
  try {
    var containerPrice = document.getElementById("purchase-subscription-price-wrapper");
    var containerTitle = document.getElementById("purchase-subscription-header-title");
    var containerText = document.getElementById("purchase-subscription-terms-of-service");
    var containerSubmit = document.getElementById("purchase-product-submit");
    var containerTaxes = document.getElementById("purchase-subscription-includes-taxes");
    let dynamicPrice = document.createElement("div");

    if (payment.discountCode !== null && freeTrialInDays !== 0) {
      dynamicPrice.innerHTML = `<span>Total billed today: ${currency}0.00</span>`;
      containerTitle.innerHTML = `MusicGurus ${freeTrialInDays / 30} month free trial`
      containerText.innerHTML = `By clicking "Start Free Trial" you will start a ${freeTrialInDays / 30} month free trial. If you do not cancel before the trial ends, you agree to be charged the ${(interval.name == "month" && interval.count == 3) ? `quarter` : interval.name}ly subscription price of ${currency}${price.toFixed(2)} per ${(interval.name == "month" && interval.count == 3) ? `quarter` : interval.name}. This can be cancelled anytime, however you will not be entitled to a refund. Full T&C's are available <a href="#">here.</a>`;
      containerSubmit.innerHTML = 'Start Free Trial';
      containerTaxes.style.display = 'none';
    } else {
      dynamicPrice.innerHTML = `<span>Total billed today: ${currency} ${price.toFixed(2)}</span>`;
    }
    containerPrice.innerHTML = dynamicPrice.innerHTML;
  }
  catch (error) {
    console.log("error", error);
  }
}

const setupPurchaseGiftForm = () => {
  const purchaseGiftForm = document.getElementById('gift-purchase-form');
  const discountGiftForm = document.getElementById('discount-purchase-gift-form');
  discount.setupForm(discountGiftForm);
  gift.setupForm(purchaseGiftForm);
}

const getProductPrices = ({ productId, productType }) => {
  const priceEl = document.querySelector(`.js-price[data-product-id="${productId}"][data-product-type="${productType}"]`);
  return { eur: priceEl.dataset.eur, gbp: priceEl.dataset.gbp, usd: priceEl.dataset.usd };
}

const getConversionRatio = ({ currency, prices, newCurrency }) => {
  return prices[newCurrency] / prices[currency];
}

const parserSecretId = (id) => {
  if (id.includes("pi")) return "pi";
  if (id.includes("seti")) return "seti";
  return 0;
}

export const convertAmount = ({ amount, currency, productId, productType, newCurrency }) => {

  const prices = getProductPrices({ productId, productType });
  const ratio = getConversionRatio({ currency, prices, newCurrency });
  return amount * ratio;
}

const gift = {
  appliedDiscountCode: null,
  clientSecret: null,
  editInfoBtn: null,
  getSubmit: null,
  infoForm: null,
  infoFormData: null,
  paypal: {
    button: null,
    createOrder: async () => {
      startLoading(gift.purchaseForm);
      gift.loading(true);
      const data = gift.fetchPaymentData();

      return new Promise((resolve, reject) => {
        const xhr = createXHR({
          method: 'POST',
          endpoint: '/api/v2/user/paypal-create-order',
          data,
        });

        xhr.onload = () => {
          if (xhr.status !== 200) {
            return reject({ xhr });
          }
          const result = JSON.parse(xhr.responseText);
          console.log(result);
          if (!result.id) {
            return reject({ xhr });
          }
          gift.paypal.id = result.id;
          return resolve(result.id);
        }
      })
        .catch(({ xhr }) => {
          Sentry.captureMessage(xhr.responseText);
          gift.showPurchaseError(xhr.responseText);
        });
    },
    id: null,
    instance: null,
    onApprove: async (data, _) => {
      return new Promise((resolve, reject) => {
        const xhr = createXHR({
          method: 'POST',
          endpoint: '/api/v2/user/paypal-capture-order',
          data,
        });

        xhr.onload = () => {
          if (xhr.status !== 200) {
            return reject({ xhr });
          }
          const result = JSON.parse(xhr.responseText);
          if (!result.id) {
            return reject({ xhr });
          }
          return resolve(result);
        }
      })
        .then(() =>
          gift.orderComplete({ withPayment: true }))
        .catch(xhr => {
          Sentry.captureMessage(xhr.responseText);
          gift.showError(JSON.parse(xhr.responseText));
        })
        .finally(() =>
          finishLoading(gift.purchaseForm))
    },
    onCancel: () => {
      finishLoading(gift.purchaseForm);
    },
    onError: error => {
      Sentry.captureMessage(error);
      // TODO: display PayPal error to user
      finishLoading(gift.purchaseForm);
    }
  },
  pristine: null,
  product: { id: null, slug: null, type: null },
  purchaseForm: null,
  purchaseFormData: null,
  purchaseSubmit: null,
  purchaseSubmitBtns: null,
  stripe: null,
  stripeCard: null,
  stripeElements: null,
  stripePaymentRequest: null,
  stripePaymentRequestBtn: null,
  initPayPal: () => {
    // PayPal
    if (gift.paypal.button === null) {
      gift.paypal.button = paypal.Buttons({
        createOrder: gift.paypal.createOrder,
        fundingSource: paypal.FUNDING.PAYPAL,
        onApprove: gift.paypal.onApprove,
        onCancel: gift.paypal.onCancel,
        onError: gift.paypal.onError,
        style: PayPalBtnStyle,
      });
    }
    if (gift.purchaseForm === null) {
      // form not yet setup
      return;
    }
    const btnLocation = document.querySelector('.js-paypal-btn-element[data-form="gift-purchase-form"]');
    if (btnLocation.length === 0 || btnLocation.children.length > 0) {
      // btn location not available or btn location already has a rendered paypal btn
      return;
    }
    if (!gift.paypal.button.isEligible()) {
      // paypal not able to render
      return;
    }
    gift.paypal.button.render(btnLocation);
  },
  setupForm: async purchaseForm => {
    gift.purchaseForm = purchaseForm;
    gift.editInfoBtn = document.getElementById('edit-gift-information');
    gift.getSubmit = document.getElementById('get-gift-product-submit');
    gift.infoForm = document.getElementById('gift-information-form');
    gift.purchaseSection = document.getElementById('gift-purchase-section');
    gift.infoFormData = new FormData(gift.infoForm);
    gift.productSubmitBtns = document.getElementById('gift-product-submit-btns');
    gift.purchaseSubmit = document.getElementById('purchase-gift-product-submit');
    gift.purchaseFormData = new FormData(gift.purchaseForm);

    const stripePublishableKey = gift.purchaseFormData.get('stripe_publishable_key');
    gift.stripe = await loadStripe(stripePublishableKey);

    // disable submit button during setup
    gift.purchaseSubmit.disabled = true;

    gift.getSubmit.addEventListener('click', event => {
      event.preventDefault();
      gift.getFreeProduct();
    });

    // click event for proceeding to payment
    gift.infoForm.addEventListener('submit', event => {
      event.preventDefault();
      // refresh form data on submit
      gift.infoFormData = new FormData(gift.infoForm);

      gift.pristine = new Pristine(gift.infoForm, PristineConfig);

      if (gift.pristine.validate()) {
        gift.switchView('purchase');
        // fetch Stripe payment intent and show purchase form
        gift.getPaymentIntent();
        gift.createPaymentRequest();
        gift.initPayPal();
      }
    });

    gift.editInfoBtn.addEventListener('click', event => {
      event.preventDefault();
      gift.switchView('info');
    });
  },
  switchView: view => {
    switch (view) {
      case 'purchase':
        // hide gift information form
        gift.infoForm.classList.add('is-hidden');
        // show payment section
        discount.form.classList.remove('is-hidden');
        gift.purchaseSection.classList.remove('is-hidden');
        break;
      case 'info':
        // hide payment section
        discount.form.classList.add('is-hidden');
        gift.purchaseSection.classList.add('is-hidden');
        // show gift information form
        gift.infoForm.classList.remove('is-hidden');
        break;
      default:
        console.error('unhandled view');
        break;
    }
  },
  fetchPaymentData: discountCodeApplied => {
    gift.product.id = parseInt(gift.purchaseFormData.get('product_id'));
    gift.product.price = gift.purchaseFormData.get('product_price');
    gift.product.slug = gift.purchaseFormData.get('product_slug');
    gift.product.type = gift.purchaseFormData.get('product_type');

    const discount_code = discount.formData.get('discount_code');
    const currency = window.localStorage.getItem('currency');

    let data = {
      currency,
      product_id: gift.product.id,
      product_price: gift.product.price,
      product_slug: gift.product.slug,
      product_type: gift.product.type,
    };

    if (discountCodeApplied && discount_code !== '') {
      gift.appliedDiscountCode = discount_code;
      data = { discount_code, ...data };
    } else if (gift.appliedDiscountCode) {
      data = { discount_code: gift.appliedDiscountCode, ...data };
    }

    // hydrate data with gift information
    const is_gift = true;
    const customer_email = gift.infoFormData.get('customer_email');
    const customer_name = gift.infoFormData.get('customer_name');
    const message = gift.infoFormData.get('message');
    const recipient_email = gift.infoFormData.get('recipient_email');
    const recipient_name = gift.infoFormData.get('recipient_name');
    const send_date = gift.infoFormData.get('send_date');

    data = { is_gift, customer_email, customer_name, recipient_email, recipient_name, ...data };

    if (message && message !== '') {
      data = { message, ...data };
    }
    if (send_date && send_date !== '') {
      data = { send_date, ...data };
    }
    return data;
  },
  getPaymentIntent: appliedDiscountCode => {
    const data = gift.fetchPaymentData(appliedDiscountCode);

    // Construct an HTTP request
    const xhr = createXHR({
      method: 'POST',
      endpoint: '/api/v2/user/create-payment-intent',
      data,
    });
    xhr.onload = () => {
      switch (xhr.status) {
        case 200:
          const result = JSON.parse(xhr.responseText)
          if (!!result.clientSecret) {
            gift.clientSecret = result.clientSecret;
          }
          if (gift.stripeElements === null && !result.isFree) {
            gift.loadStripeElements();
          }
          break;
        default:
          return gift.showPurchaseError(xhr.responseText);
      }
    }
  },
  createPaymentRequest: appliedDiscountCode => {
    const country = window.localStorage.getItem('countryCode') || 'US';

    const data = gift.fetchPaymentData(appliedDiscountCode);
    gift.stripePaymentRequest = gift.stripe.paymentRequest({
      country,
      currency: data.currency.toLowerCase(),
      total: {
        label: data.product_slug,
        amount: parseInt(data.product_price) * 100, // Stripe works in cents
      },
      requestPayerName: false,
      requestPayerEmail: false,
    });
  },
  getFreeProduct: () => {
    const data = gift.fetchPaymentData();
    startLoading(gift.purchaseForm);

    // Construct an HTTP request
    const xhr = createXHR({
      method: 'POST',
      endpoint: '/api/v2/user/get-free-product',
      data,
    });
    xhr.onload = () => {
      finishLoading(gift.purchaseForm);
      switch (xhr.status) {
        case 200:
          gift.orderComplete();
          break;
        default:
          return gift.showError(xhr.responseText);
      }
    }
  },
  loading: isLoading => {
    if (isLoading) {
      document.querySelectorAll('.js-transaction-in-progress').forEach(el => el.classList.remove('is-hidden'));
      gift.purchaseSubmit.disabled = true;
      gift.getSubmit.disabled = true;
    } else {
      document.querySelectorAll('.js-transaction-in-progress').forEach(el => el.classList.add('is-hidden'));
      gift.purchaseSubmit.disabled = false;
      gift.getSubmit.disabled = false;
    }
  },
  loadStripeElements: () => {
    gift.stripeElements = gift.stripe.elements();
    const style = {
      base: {
        color: '#32325d',
        fontFamily: 'Arial, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d"
        }
      },
      invalid: {
        fontFamily: 'Arial, sans-serif',
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };

    // Stripe: Credit Card
    gift.stripeCard = gift.stripeElements.create('card', { style });
    // Stripe injects an iframe into the DOM for Credit Card Payments
    gift.stripeCard.mount(gift.purchaseForm.querySelector('.js-card-element'));
    gift.stripeCard.on('change', gift.manageFormOnChange);

    // Stripe: Payment Request
    gift.stripePaymentRequestBtn = gift.stripeElements.create('paymentRequestButton', {
      paymentRequest: gift.stripePaymentRequest
    });
    // Stripe injects an iframe into the DOM for Apple Pay
    gift.stripePaymentRequest.canMakePayment().then(result => {
      const reqBtnEl = document.querySelector('.js-payment-request-btn-element[data-form="gift-purchase-form"]');
      if (result) {
        gift.stripePaymentRequestBtn.mount(reqBtnEl);
      } else {
        reqBtnEl.classList.add('is-hidden');
      }
    });

    gift.stripePaymentRequest.on('paymentmethod', gift.paymentMethodHook);

    gift.purchaseForm.addEventListener('submit', gift.submitPurchaseForm);
  },
  manageFormOnChange: event => {
    // Disable the Pay button if there are no card details in the Element
    gift.purchaseSubmit.disabled = event.empty;
    gift.purchaseForm.querySelector('.js-purchase-form-error').textContent = event.error ? event.error.message : '';
  },
  paymentMethodHook: ev => {
    // Confirm the PaymentIntent without handling potential next actions (yet).
    gift.stripe.confirmCardPayment(
      gift.clientSecret,
      { payment_method: ev.paymentMethod.id },
      { handleActions: false }
    ).then(({ paymentIntent, error }) => {
      if (error) {
        // Report to the browser that the payment failed, prompting it to
        // re-show the payment interface, or show an error message and close
        // the payment interface.
        ev.complete('fail');
        throw { error };
      }

      // Report to the browser that the confirmation was successful, prompting
      // it to close the browser payment method collection interface.
      ev.complete('success');
      // Check if the PaymentIntent requires any actions and if so let Stripe.js
      // handle the flow. If using an api version older than "2019-02-11" instead
      // instead check for: `paymentIntent.status === "requires_source_action"`.
      if (paymentIntent.status === "requires_action") {
        // Let Stripe.js handle the rest of the payment flow.
        return gift.stripe.confirmCardPayment(clientSecret);
      }
      return Promise.resolve({ paymentIntent });
    }).then(({ paymentIntent, error }) => {
      if (error) {
        throw { error };
      }
      // The payment succeeded!
      return;
    }).then(() =>
      gift.orderComplete({ withPayment: true }))
      .catch(({ error }) => {
        Sentry.captureException(error);
        gift.showPurchaseError(error.message);
      })
      .finally(() =>
        finishLoading(gift.purchaseForm));
  },
  orderComplete: withPayment => {
    window.localStorage.removeItem('discount_code');
    document.querySelectorAll('.js-transaction-in-progress').forEach(el =>
      el.classList.add('is-hidden'));
    if (withPayment) {
      document.querySelectorAll('.js-payment-success').forEach(el =>
        el.classList.remove('is-hidden'));
    }
    // reset forms and close overlay
    gift.infoForm.reset();
    gift.purchaseForm.reset();
    setTimeout(() => {
      gift.switchView('info');
      document.querySelectorAll('.o-overlay').forEach(el => el.classList.add('is-hidden'))
    }, 3000);
  },
  payWithApplePay: event => {
    startLoading(gift.purchaseForm);
    gift.loading(true);
    gift.stripe
      .confirmCardPayment(
        gift.clientSecret,
        { payment_method: event.paymentMethod.id },
        { handleActions: false },
      )
      .then(({ paymentIntent, error }) => {
        if (error) {
          throw { error };
        }

        if (paymentIntent.status === "requires_action") {
          // Let Stripe.js handle the rest of the payment flow.
          return gift.stripe.confirmCardPayment(clientSecret);
        }
        return Promise.resolve({ paymentIntent });
      })
      .then(({ paymentIntent, error }) => {
        if (error) {
          throw { error };
        }
        // The payment succeeded!
        return;
      })
      .then(() =>
        gift.orderComplete({ withPayment: true }))
      .catch(({ error }) => {
        Sentry.captureException(error);
        gift.showPurchaseError(error.message);
      })
      .finally(() =>
        finishLoading(gift.purchaseForm))
  },
  payWithCard: (card, clientSecret) => {
    startLoading(gift.purchaseForm);
    gift.loading(true);
    gift.stripe
      .confirmCardPayment(clientSecret, {
        payment_method: { card }
      })
      .then(result => {
        if (result.error) {
          throw result.error;
        }
        // The payment succeeded!
        return;
      })
      .then(() =>
        gift.orderComplete({ withPayment: true }))
      .catch(error => {
        Sentry.captureException(error);
        gift.showPurchaseError(error.message);
      })
      .finally(() =>
        finishLoading(gift.purchaseForm));
  },
  showPurchaseError: (errorMsgText) => {
    gift.loading(false);
    const errorMsg = gift.purchaseForm.querySelector('.js-purchase-form-error');
    errorMsg.textContent = errorMsgText;
    setTimeout(() => {
      errorMsg.textContent = "";
    }, 4000);
  },

  showGlobalError: ({ response, persist }) => {
    const globalErrorEl = document.getElementById('gift-purchase-form-global-error');
    globalErrorEl.classList.remove('is-hidden');
    globalErrorEl.textContent = response.error;
    if (persist) {
      return;
    }
    setTimeout(() =>
      document.querySelectorAll('.o-overlay').forEach(el => el.classList.add('is-hidden')), 4000);
  },
  submitPurchaseForm: (event) => {
    event.preventDefault();
    // Complete payment when the submit button is clicked
    gift.payWithCard(gift.stripeCard, gift.clientSecret);
  }
};

const payment = {
  discountCode: null,
  appliedDiscountCode: null,
  clientSecret: null,
  form: null,
  formData: null,
  getSubmit: null,
  paypal: {
    button: null,
    createOrder: async () => {
      startLoading(payment.form);
      payment.loading(true);
      const data = payment.fetchPaymentData();
      return new Promise((resolve, reject) => {
        const xhr = createXHR({
          method: 'POST',
          endpoint: '/api/v2/user/paypal-create-order',
          data,
        });

        xhr.onload = () => {
          if (xhr.status !== 200) {
            return reject({ xhr });
          }
          const result = JSON.parse(xhr.responseText);
          if (!result.id) {
            return reject({ xhr });
          }
          payment.paypal.id = result.id;
          return resolve(result.id);
        }
      })
        .catch(({ xhr }) => {
          switch (xhr.status) {
            case 403:
              Sentry.captureMessage('You already own this product');
              return payment.showGlobalError({ response: { error: 'You already own this product' } });
            case 404:
              Sentry.captureMessage('Unknown product');
              payment.showError({ error: 'Unknown product' });
              break;
            case 422:
              Sentry.captureMessage(xhr.responseText);
              payment.showError(JSON.parse(xhr.responseText));
              break;
            default:
              Sentry.captureMessage('We are experiencing an issue communicating with PayPal, please use an alternative payment method.');
              payment.showGlobalError({
                response: {
                  error: 'We are experiencing an issue communicating with PayPal, please use an alternative payment method.'
                },
                persist: true,
              });
              break;
          }
          finishLoading(payment.form);
        });
    },
    id: null,
    instance: null,
    onApprove: async (data, _) => {
      return new Promise((resolve, reject) => {
        const xhr = createXHR({
          method: 'POST',
          endpoint: '/api/v2/user/paypal-capture-order',
          data,
        });

        xhr.onload = () => {
          if (xhr.status !== 200) {
            return reject({ xhr });
          }
          const result = JSON.parse(xhr.responseText);
          if (!result.id) {
            return reject({ xhr });
          }
          return resolve(result);
        }
      })
        .then(() =>
          payment.orderComplete({ withPayment: true }))
        .catch(xhr => {
          Sentry.captureMessage(xhr.responseText);
          payment.showError(JSON.parse(xhr.responseText));
        })
        .finally(() =>
          finishLoading(payment.form))
    },
    onCancel: () => {
      finishLoading(payment.form);
    },
    onError: error => {
      Sentry.captureMessage(error);
      // TODO: display PayPal error to user
      finishLoading(payment.form);
    }
  },
  product: { id: null, price: null, slug: null, type: null },
  stripe: null,
  stripeCard: null,
  stripeElements: null,
  stripePaymentRequest: null,
  stripePaymentRequestBtn: null,
  initPayPal: () => {
    if (payment.paypal.button === null) {
      payment.paypal.button = paypal.Buttons({
        createOrder: payment.paypal.createOrder,
        fundingSource: paypal.FUNDING.PAYPAL,
        onApprove: payment.paypal.onApprove,
        onCancel: payment.paypal.onCancel,
        onError: payment.paypal.onError,
        style: PayPalBtnStyle,
      });
    }
    if (payment.form === null) {
      // form not yet setup
      return;
    }
    // const btnLocation = document.querySelector('.js-paypal-btn-element[data-form="purchase-form"]');
    const btnLocation = document.querySelector('.js-paypal-btn-element[data-form="purchase-subscription-form"]');
    if (btnLocation.length === 0 || btnLocation.children.length > 0) {
      // btn location not available or btn location already has a rendered paypal btn
      return;
    }
    if (!payment.paypal.button.isEligible()) {
      // paypal not able to render
      return;
    }
    payment.paypal.button.render(btnLocation);
  },
  setupForm: async (form) => {
    try {
      payment.form = form;
      payment.formData = new FormData(form);
      payment.getSubmit = document.getElementById('get-product-submit');
      payment.purchaseSubmit = document.getElementById('purchase-product-submit');
      // STRIPE
      const stripePublishableKey = payment.formData.get('stripe_publishable_key');
      payment.stripe = await loadStripe(stripePublishableKey);
      // disable submit button during setup
      payment.purchaseSubmit.disabled = true;
      payment.getPaymentIntent();
      payment.createPaymentRequest();

      // PayPal
      // payment.initPayPal();

      payment.getSubmit.addEventListener('click', event => {
        event.preventDefault();
        payment.getFreeProduct();
      });
    }
    catch (error) {
      console.log("setupForm error", error);
    }
  },
  installationDiscount: discount => {
    payment.discountCode = discount;
  },
  fetchPaymentData: discountCodeApplied => {
    payment.product.id = parseInt(payment.formData.get('product_id'));
    //payment.product.price = payment.formData.get('product_price');
    payment.product.slug = payment.formData.get('product_slug');
    payment.product.type = payment.formData.get('product_type');
    const currency = window.localStorage.getItem('currency');
    let data = {
      currency,
      product_id: payment.product.id,
      //product_price: payment.product.price,
      product_slug: payment.product.slug,
      product_type: payment.product.type,
    };

    if (discountCodeApplied) {
      const discount_code = discount?.formData?.get('discount_code');
      if (discount_code !== '') {
        payment.appliedDiscountCode = discount_code;
        data = { discount_code, ...data };
      }
    } else if (payment.appliedDiscountCode) {
      data = { discount_code: payment.appliedDiscountCode, ...data };
    }
    return data;
  },
  getPaymentIntent: appliedDiscountCode => {
    const data = payment.fetchPaymentData(appliedDiscountCode);

    // Construct an HTTP request
    const xhr = createXHR({
      method: 'POST',
      endpoint: '/api/v2/user/create-payment-intent',
      data,
    });
    xhr.onload = () => {
      let error = null;
      switch (xhr.status) {
        case 200:
          const result = JSON.parse(xhr.responseText);
          if (!!result.clientSecret) {
            payment.clientSecret = result.clientSecret;
          }
          if (payment.stripeElements === null && !result.isFree) {
            payment.loadStripeElements();
          }

          break;
        case 403:
          error = 'You already own this product';
          Sentry.captureMessage(error);
          return payment.showGlobalError({ response: { error } });
        case 404:
          error = 'Unknown product';
          Sentry.captureMessage(error);
          return payment.showError({ error });
        case 422:
          error = xhr.responseText;
          Sentry.captureMessage(error);
          return payment.showError(JSON.parse(error));
        default:
          Sentry.captureMessage('Unhandled status');
          break;
      }
    }
  },
  getSubscriptionRelevance: async () => {
    let result, data;
    if (!!payment.discountCode) {
      data = {};
    }
    else {
      data = payment.fetchPaymentData();
    }
    return new Promise((resolve, reject) => {
      const xhr = createXHR({
        method: 'POST',
        endpoint: '/api/v2/course/start-course',
        data,
      });
      xhr.onload = () => {
        if (xhr.status !== 200) {
          return reject({ xhr });
        }
        result = JSON.parse(xhr.responseText);
        if (!result) {
          return reject({ xhr });
        }
        return resolve(result);
      }
    })
  },
  activateGiftCode: async () => {
    let result;
    Sentry.captureMessage("good");
    return new Promise((resolve, reject) => {
      const xhr = createXHR({
        method: 'POST',
        endpoint: '/api/v2/user/activate-gift-code',
      });

      xhr.onload = () => {
        let error = null;
        switch (xhr.status) {
          case 200:
            result = JSON.parse(xhr.responseText);
            break;

          case 400:
            error = 'Unknown product';
            Sentry.captureMessage(error);
            return reject({ xhr })
          default:
            Sentry.captureMessage('Unhandled status');
            break;
        }
        return resolve(result);
      }
    })
  },
  getSubscriptionsStatus: async () => {
    let result;
    return new Promise((resolve, reject) => {
      const xhr = createXHR({
        method: 'GET',
        endpoint: '/api/v2/user/status',
      });

      xhr.onload = () => {
        if (xhr.status !== 200) {
          return reject({ xhr });
        }
        result = JSON.parse(xhr.responseText);
        if (!result) {
          return reject({ xhr });
        }
        return resolve(result);
      }
    })
  },
  getPaymentLink: async () => {
    let result;
    return new Promise((resolve, reject) => {
      const xhr = createXHR({
        method: 'GET',
        endpoint: '/api/v2/user/latest_subscription_payment_link',
      });

      xhr.onload = () => {
        if (xhr.status !== 200) {
          return reject({ xhr });
        }
        result = JSON.parse(xhr.responseText);
        if (!result) {
          return reject({ xhr });
        }
        return resolve(result);
      }
    })
  },
  getProductsWithSubscriptions: async () => {
    let result;
    return new Promise((resolve, reject) => {
      const xhr = createXHR({
        method: 'GET',
        endpoint: '/api/v2/user/get-prices-with-subscriptions',
      });

      xhr.onload = () => {
        if (xhr.status !== 200) {
          return reject({ xhr });
        }
        result = JSON.parse(xhr.responseText);
        if (!result) {
          return reject({ xhr });
        }
        return resolve(result);
      }
    })
  },
  createSubscription: async (priceId, cardTokenId) => {
    let productData;
    let result, data;
    //startLoading(payment.form);
    //payment.loading(true);
    if (!!payment.discountCode) {
      productData = {};
      data = { "product_type": "site", "price_id": priceId, "product_id": 7556, "card_token": cardTokenId };
    }
    else {
      productData = payment.fetchPaymentData();
      data = { "product_type": "site", "price_id": priceId, "product_id": productData.product_id, "card_token": cardTokenId };
    }
    return new Promise((resolve, reject) => {


      const xhr = createXHR({
        method: 'POST',
        endpoint: '/api/v2/user/create-subscription',
        data,
      });
      xhr.onload = () => {
        if (xhr.status !== 200) {
          return reject({ xhr });
        }
        finishLoading(payment.form)
        result = JSON.parse(xhr.responseText);
        if (!result) {
          return reject({ xhr });
        }
        if (!!result.clientSecret) {
          payment.clientSecret = result.clientSecret;
        }
        if (payment.stripeElements === null && !result.isFree) {
          payment.loadStripeElements();
        }
        return resolve(result);
      }
    })
  },
  redeemACode: async () => {
    let result;
    //startLoading(payment.form);
    // payment.loading(true);
    let data = {
      code: payment.discountCode
    }
    return new Promise((resolve, reject) => {
      const xhr = createXHR({
        method: 'POST',
        endpoint: '/api/v2/user/redeem-gift-code',
        data,
      });
      xhr.onload = () => {
        if (xhr.status !== 200) {
          return reject(JSON.parse(xhr.responseText));
        }
        finishLoading(payment.form)
        result = JSON.parse(xhr.responseText);
        //console.log("redeemACode3",result);
        if (!result) {
          return reject({ xhr });
        }
        return resolve(result);
      }
    })
  },

  createPaymentRequest: appliedDiscountCode => {

    const country = window.localStorage.getItem('countryCode') || 'US';

    const data = payment.fetchPaymentData(appliedDiscountCode);
    try {
      payment.stripePaymentRequest = payment.stripe.paymentRequest({
        country,
        currency: data.currency.toLowerCase(),
        total: {
          label: data.product_slug,
          amount: 1, // Stripe works in cents
        },
        requestPayerName: false,
        requestPayerEmail: false,
      });
    }
    catch (error) {
      console.log("error createPaymentRequest", error);
    }
  },
  getFreeProduct: () => {
    const data = payment.fetchPaymentData();
    startLoading(payment.form);

    // Construct an HTTP request
    const xhr = createXHR({
      method: 'POST',
      endpoint: '/api/v2/user/get-free-product',
      data,
    });
    xhr.onload = () => {
      switch (xhr.status) {
        case 200:
          payment.orderComplete({ withPayment: true });
          break;
        default:
          finishLoading(payment.form);
          let error = xhr.responseText;
          Sentry.captureMessage(error);
          return payment.showError(JSON.parse(error));
      }
    }
  },
  loading: (isLoading) => {
    if (isLoading) {
      document.querySelectorAll('.js-transaction-in-progress').forEach(el => el.classList.remove('is-hidden'));
      payment.purchaseSubmit.disabled = true;
      payment.getSubmit.disabled = true;
      // payment.form.querySelector('.js-purchase-form-spinner').classList.remove('is-hidden');
    } else {
      document.querySelectorAll('.js-transaction-in-progress').forEach(el => el.classList.add('is-hidden'));
      payment.purchaseSubmit.disabled = false;
      payment.getSubmit.disabled = false;
      // payment.form.querySelector('.js-purchase-form-spinner').classList.add('is-hidden');
    }
  },
  loadStripeElements: () => {
    try {
      payment.stripeElements = payment.stripe.elements();
      const style = {
        base: {
          color: '#32325d',
          fontFamily: 'Arial, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#32325d"
          },
          padding: '2px',
        },
        invalid: {
          fontFamily: 'Arial, sans-serif',
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      // Stripe: Credit Card
      payment.stripeCard = payment.stripeElements.create('card', { style });
      // Stripe injects an iframe into the DOM for Credit Card Payments
      payment.stripeCard.mount(payment.form.querySelector('.js-card-element'));
      payment.stripeCard.on('change', payment.manageFormOnChange);

      // Stripe: Payment Request
      payment.stripePaymentRequestBtn = payment.stripeElements.create('paymentRequestButton', {
        paymentRequest: payment.stripePaymentRequest
      });
      // Stripe injects an iframe into the DOM for Apple Pay
      payment.stripePaymentRequest.canMakePayment().then(result => {
        const reqBtnEl = document.querySelector('.js-payment-request-btn-element[data-form="purchase-form"]')
        if (result) {
          payment.stripePaymentRequestBtn.mount(reqBtnEl);
        } else {
          reqBtnEl.classList.add('is-hidden');
        }
      });

      payment.stripePaymentRequest.on('paymentmethod', payment.paymentMethodHook);

      payment.form.addEventListener('submit', payment.submitForm);
    }
    catch (err) {
      console.log("loadStripeElements error", err);
    }
  },
  manageFormOnChange: event => {
    // Disable the Pay button if there are no card details in the Element
    payment.purchaseSubmit.disabled = event.empty;
    payment.form.querySelector('.js-purchase-form-error').textContent = event.error ? event.error.message : '';
  },
  paymentMethodHook: ev => {
    // Confirm the PaymentIntent without handling potential next actions (yet).
    payment.stripe.confirmCardPayment(
      payment.clientSecret,
      { payment_method: ev.paymentMethod.id },
      { handleActions: false }
    ).then(({ paymentIntent, error }) => {
      if (error) {
        // Report to the browser that the payment failed, prompting it to
        // re-show the payment interface, or show an error message and close
        // the payment interface.
        ev.complete('fail');
        throw { error };
      }

      // Report to the browser that the confirmation was successful, prompting
      // it to close the browser payment method collection interface.
      ev.complete('success');
      // Check if the PaymentIntent requires any actions and if so let Stripe.js
      // handle the flow. If using an api version older than "2019-02-11" instead
      // instead check for: `paymentIntent.status === "requires_source_action"`.
      if (paymentIntent.status === "requires_action") {
        // Let Stripe.js handle the rest of the payment flow.
        return payment.stripe.confirmCardPayment(clientSecret);
      }
      return Promise.resolve({ paymentIntent });
    }).then(({ paymentIntent, error }) => {
      if (error) {
        throw { error };
      }
      // The payment succeeded!
      return;
    }).then(() =>
      payment.orderComplete({ withPayment: true }))
      .catch(({ error }) => {
        Sentry.captureException(error);
        payment.showError(error.message);
      })
      .finally(() =>
        finishLoading(payment.form));
  },
  orderComplete: withPayment => {
    //window.localStorage.removeItem('discount_code');
    //document.querySelectorAll('.js-transaction-in-progress').forEach(el =>
    //el.classList.add('is-hidden'));
    if (withPayment) {
      document.querySelectorAll('.js-payment-success').forEach(el =>
        el.classList.remove('is-hidden'));
    }
    payment.getSubscriptionRelevance().then(() => { })
    setTimeout(() => {
      // send user to product in the dashboard
      finishLoading(payment.form)
      payment.purchaseSubmit.disabled = false;
      window.location.href = `${DASHBOARD_URL}/${dashboardProductMap[payment.product.type]}/${payment.product.slug}`;
    }, 4000);
  },
  payWithApplePay: event => {
    startLoading(payment.form);
    payment.loading(true);
    payment.stripe
      .confirmCardPayment(
        payment.clientSecret,
        { payment_method: event.paymentMethod.id },
        { handleActions: false },
      )
      .then(({ paymentIntent, error }) => {
        if (error) {
          throw { error };
        }

        if (paymentIntent.status === "requires_action") {
          // Let Stripe.js handle the rest of the payment flow.
          return payment.stripe.confirmCardPayment(clientSecret);
        }
        return Promise.resolve({ paymentIntent });
      })
      .then(({ paymentIntent, error }) => {
        if (error) {
          throw { error };
        }
        // The payment succeeded!
        return;
      })
      .then(() =>
        payment.orderComplete({ success: true }))
      .catch(({ error }) => {
        Sentry.captureException(error);
        payment.showError(error.message);
      })
      .finally(() =>
        finishLoading(payment.form))
  },
  confirmCardSetup: async (clientSecret) => {
    startLoading(payment.form);
    console.log('ConfirmCardSetup');
    // payment.loading(true);

    payment.stripe
      .confirmCardSetup(clientSecret)
      .then(result => {
        if (result.error) {
          throw result.error;
        }
        return;
      })
      .then(() => {
        return payment.orderComplete({ withPayment: true })
      })
      .catch(error => {
        Sentry.captureException(error);
        payment.showError(error.message);
        console.log("Error: " + error.message);
        finishLoading(payment.form)
        payment.purchaseSubmit.disabled = false;
      })
  },
  payWithCard: async (card, clientSecret) => {
    startLoading(payment.form);
    console.log('PayWithCard');
    // payment.loading(true);

    const options = {}
    if (card !== null) {
      options["payment_method"] = { card }
    }

    payment.stripe
      .confirmCardPayment(clientSecret, options)
      .then(result => {
        if (result.error) {
          throw result.error;
        }
        // The payment succeeded!
        return;
      })
      .then(() => {
        return payment.orderComplete({ withPayment: true })
      })
      .catch(error => {
        Sentry.captureException(error);
        payment.showError(error.message);
        console.log("Error: " + error.message);
        finishLoading(payment.form)
        payment.purchaseSubmit.disabled = false;
      })
      .finally(() => {
        let getIsPaid;
        payment.getPaymentLink().then((result) => {//need start before payment
          if (!result.is_paid) {
            window.open(result.payment_link);
            const makeApiCall = () => {
              payment.getPaymentLink().then((result) => {
                if (result.is_paid) {
                  window.clearTimeout(getIsPaid);
                  // console.log('activateGiftCode');
                  // payment.activateGiftCode().then((res) => {
                  // }).catch((err) => {
                  //   console.log("activateGiftCode err", err);
                  // })
                }
              })
            }
            // Initiate call
            getIsPaid = setTimeout(makeApiCall(), 5000);
            setTimeout(window.clearTimeout(getIsPaid), 120000);
          }
          else {
            // window.location.href = `${DASHBOARD_URL}`;
            // payment.activateGiftCode().then((res) => {
            //   window.location.href = `${DASHBOARD_URL}`;
            // }).catch((err) => {
            //   console.log("activateGiftCode err", err);
            // })
            setTimeout(() => {
              // send user to product in the dashboard
              finishLoading(payment.form)
              payment.purchaseSubmit.disabled = false;
              window.location.href = `${DASHBOARD_URL}/${dashboardProductMap[payment.product.type]}/${payment.product.slug}`;
            }, 1000)
          }
        })
      });
  },
  showError: response => {
    payment.loading(false);
    if (response.hasOwnProperty('error')) {
      const errorMsg = payment.form.querySelector('.js-purchase-form-error');
      errorMsg.textContent = response.error;
      setTimeout(() => {
        errorMsg.textContent = "";
      }, 4000);
    }
  },
  showGlobalError: ({ response, persist }) => {
    const globalErrorEl = document.getElementById('purchase-form-global-error');
    globalErrorEl.classList.remove('is-hidden');
    globalErrorEl.textContent = response.error;
    if (persist) {
      return;
    }
    setTimeout(() =>
      document.querySelectorAll('.o-overlay').forEach(el => el.classList.add('is-hidden')), 4000);
  },
  submitForm: event => {
    NOTE:
    event.preventDefault();
    console.log('submitForm');
    startLoading(payment.form);
    payment.purchaseSubmit.disabled = true;

    const formType = payment.purchaseSubmit.getAttribute("form");
    if (formType === 'purchase-subscription-form') {
      //Complete payment when the submit button is clicked
      payment.stripe.createToken(payment.stripeCard).then(res => {
        if (res.error) {
          console.err('failed to create token');
          console.err(res.error)
          return;
        }
        const cardTokenId = res.token.id

        payment.createSubscription(payment.priceId, cardTokenId).then(res => {
          if (parserSecretId(res.clientSecret) !== "pi") {
            payment.confirmCardSetup(payment.clientSecret);
          } else {
            payment.payWithCard(null, payment.clientSecret);
          }
        })
      }).catch(() => {
        finishLoading(payment.form);
        payment.purchaseSubmit.disabled = false;
      })
    } else {
      payment.payWithCard(payment.stripeCard, payment.clientSecret);
    }
  }
};

const discount = {
  form: null,
  formData: null,
  pristine: null,

  setupForm: form => {
    discount.form = form;
    discount.formData = new FormData(form);
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('discount_code')) {
      const discount_code = urlParams.get('discount_code')
      window.localStorage.setItem('discount_code', discount_code);
      form.querySelector('input[name="discount_code"]').value = discount_code;
      discount.applyDiscount();
    }

    // Pre-validate discount codes using AJAX
    form.addEventListener('submit', event => {
      event.preventDefault();
      discount.applyDiscount();
    });
  },

  applyDiscount: () => {
    // discount.form.querySelector('.js-discount-spinner').classList.add('is-hidden');
    discount.form.querySelector('.js-discount-correct').classList.add('is-hidden');

    const pristine = new Pristine(discount.form, PristineConfig);

    if (pristine.validate()) {
      discount.preValidate(pristine);
    }
  },

  preValidate: (pristine) => {
    const formData = new FormData(discount.form);
    discount.formData = formData;
    const params = new URLSearchParams(formData).toString();

    startLoading(discount.form);

    // Construct an HTTP request
    const xhr = createXHR({
      method: 'GET',
      endpoint: `/api/v2/discount-code/validate?${params}`,
    });

    xhr.onload = () => {
      finishLoading(discount.form);
      switch (xhr.status) {
        case 200:
          discount.validationSuccess(JSON.parse(xhr.responseText))
          break;
        case 422:
          discount.parseErrors(JSON.parse(xhr.responseText), pristine);
          break;
        default:
          Sentry.captureMessage(`unknown status = ${xhr.status}`);
          break;
      }
    }
  },

  // Parse server errors and display with relevant input field
  parseErrors: (data, pristine) => {
    if (data.hasOwnProperty('error') && data.error.hasOwnProperty('discount')) {
      const input = discount.form.querySelector('input[name="discount_code"]');
      pristine.addError(input, data.error.discount);
    }
    discount.form.querySelector('button[type="submit"]').disabled = false;
  },

  validationSuccess: response => {
    discount.show(response);
    if (discount.formData.has('is_gift')) {
      gift.getPaymentIntent(true);
    } else {
      payment.getPaymentIntent(true);
    }
  },

  show: response => {
    const currency = window.localStorage.getItem('currency');

    if (response.data.new_prices[currency] === 0) {
      document.querySelectorAll('.js-price').forEach(el => {
        el.dataset.eur = 'FREE';
        el.dataset.gbp = 'FREE';
        el.dataset.usd = 'FREE';
        el.textContent = 'FREE';
        el.classList.add('c-price--free');
      });
      document.querySelectorAll('.js-price-input').forEach(el => {
        el.dataset.eur = 0;
        el.dataset.gbp = 0;
        el.dataset.usd = 0;
        el.value = 0;
      });
    } else {
      document.querySelectorAll('.js-price').forEach(el => {
        el.dataset.eur = response.data.new_prices.EUR;
        el.dataset.gbp = response.data.new_prices.GBP;
        el.dataset.usd = response.data.new_prices.USD;
        el.textContent = response.data.new_prices[currency];
        el.classList.remove('c-price--free');
      });
      document.querySelectorAll('.js-price-input').forEach(el => {
        el.dataset.eur = response.data.new_prices.EUR;
        el.dataset.gbp = response.data.new_prices.GBP;
        el.dataset.usd = response.data.new_prices.USD;
        el.value = response.data.new_prices[currency];
      });
    }

    // discount.form.querySelector('.js-discount-spinner').classList.add('is-hidden');
    discount.form.querySelector('.js-discount-correct').classList.remove('is-hidden');

    discount.convertForm(response.data.new_prices[currency] === 0);
  },
  convertForm: isFree => {
    let cardEl;
    let paymentFormSubmitEl
    let getFormSubmitEl;

    if (discount.formData.has('is_gift')) {
      cardEl = gift.purchaseForm.querySelector('.js-card-element');
      paymentFormSubmitEl = gift.purchaseSubmit;
      getFormSubmitEl = gift.getSubmit;
    } else {
      cardEl = payment.form.querySelector('.js-card-element');
      paymentFormSubmitEl = payment.purchaseSubmit;
      getFormSubmitEl = payment.getSubmit;
    }
    if (isFree) {
      cardEl.parentNode.classList.add('is-hidden');
      paymentFormSubmitEl.classList.add('is-hidden');
      paymentFormSubmitEl.setAttribute('disabled', true);
      getFormSubmitEl.classList.remove('is-hidden');
      getFormSubmitEl.removeAttribute('disabled');
    } else {
      cardEl.parentNode.classList.remove('is-hidden');
      paymentFormSubmitEl.classList.remove('is-hidden');
      paymentFormSubmitEl.removeAttribute('disabled');
      getFormSubmitEl.classList.add('is-hidden');
      getFormSubmitEl.setAttribute('disabled', true);
    }
  }
};

export default { convertAmount, discount, init, openGiftOverlay, openPurchaseOverlay, payment, openSelectionSubscriptionOverlayWithDiscount, openSelectionSubscriptionOverlay };